<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
        <span>Nuget feed configuration</span>
    </h4>
</div>

<div class="modal-body">
    <dx-data-grid biz-grid
                    [selection]='{ mode: "none" }'
                    [dataSource]="nugetFeeds"
                    [bizSetGroupPanel]="false"
                    [bizSetColumnChooser]="false"
                    [bizSetAllowColumnReordering]="false"
                    [bizSetPager]="false"
                    [showResetButton]="false"
                    [bizSetSearchPanel]="false"
                    [bizHideSelectedRowsCompnent]="true"
                    (onInitNewRow)="onInitNewRow($event)"
                    (onRowInserting)="onRowInserting($event)"
                    (onRowUpdating)="onRowUpdating($event)"
                    (onRowRemoving)="onRowRemoving($event)">

        <dxo-editing mode="popup" [allowUpdating]="true" [allowAdding]="true" [allowDeleting]="true">
        </dxo-editing>

        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

        <dxo-group-panel [visible]="false"></dxo-group-panel>

        <dxi-column dataField="Name" caption="Name" dataType="string" sortOrder="asc">
            <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="Url" caption="Feed URL" dataType="string" width="45%">
            <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="Username" caption="Username" dataType="string">
        </dxi-column>
        <dxi-column [calculateDisplayValue]="getMaskedPassword" dataField="Password" caption="Password" dataType="string" width="25%" editCellTemplate="password">
        </dxi-column>

        <dxi-column type="buttons">
        </dxi-column>

        <div *dxTemplate="let pw of 'password'">
            <app-password-field (valueChange)="onPasswordValueChanged($event, pw)" (cleared)="onPasswordCleared(pw)" [secretId]="pw.value"></app-password-field>
        </div>

    </dx-data-grid>
</div>

<div class="modal-footer">
    <div class="text-center">
        <button type="button" class="btn btn-primary mw-12" (click)="ok()">Close</button>
    </div>
</div>
